export const gameStatus = {
  FINISHED: 'Finished',
  PENDING: 'Pending',
};
